module.exports = __webpack_public_path__ + "static/media/fantprod-logo.44a96bb3.svg";